import { useState } from "react";
import { FaUser, FaImage, FaVideo, FaPenFancy } from "react-icons/fa";
import { MdCelebration } from "react-icons/md";
import { AiOutlineSend } from "react-icons/ai";
import MainNavbar from '../MainNavbar';
import axios from "axios";
import './SuccessStoryForm.css';
import { Helmet } from "react-helmet";
import { useContext } from "react";
import AlertContext from "../../../contexts/AlertContext";

function SuccessStoryForm() {
  const [story, setStory] = useState({
    name: "",
    description: "",
    specialMoment: "",
    image: "",
    video: "",
  });

  const [error, setError] = useState("");
  const { showAlert } = useContext(AlertContext);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setStory((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;

    if (name === "image" && files.length > 0) {
      setStory({ ...story, image: files[0], video: "" });
    } else if (name === "video" && files.length > 0) {
      setStory({ ...story, video: files[0], image: "" });
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // ---------- 1. Word‑count validation ----------
    const countWords = (t) => t.trim().split(/\s+/).length;
    const descWords = countWords(story.description);
    const momentWords = countWords(story.specialMoment);

    if (descWords < 15 || descWords > 20) {
      setError("Description must be between 15 and 20 words.");
      return;
    }
    if (momentWords < 10 || momentWords > 15) {
      setError("Special moment must be between 10 and 15 words.");
      return;
    }

    // ---------- 2. File validation ----------
    if (story.image && story.video) {
      setError("Please upload either a photo or a video, not both.");
      return;
    }
    if (!story.image && !story.video) {
      setError("Please upload at least a photo or a video.");
      return;
    }

    setError("");

    // ---------- 3. Convert the file to Base64 ----------
    const file = story.image || story.video;

    const toBase64 = (fileObj) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);   // includes data:image/... prefix
        reader.onerror = (err) => reject(err);
        reader.readAsDataURL(fileObj);                     // important!
      });

    try {
      const fileBase64 = await toBase64(file);

      // ---------- 4. POST JSON to the server ----------
      const payload = {
        name: story.name,
        description: story.description,
        specialMoment: story.specialMoment,
        fileBase64     // backend inspects prefix to decide image vs video
      };

      const { data } = await axios.post(
        "https://back.varankal.com/api/success-stories",
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("Story submitted:", data);
      showAlert("Success Story submitted! 💕");

      // ---------- 5. Reset form ----------
      setStory({
        name: "",
        description: "",
        specialMoment: "",
        image: "",
        video: "",
      });
    } catch (err) {
      console.error("Submission error:", err);
      setError("Something went wrong. Please try again.");
    }
  };


  return (
    <>
      <MainNavbar />
      <section className="success-story-form-container">
        <Helmet>
          <title>Varankal Success Stories | Tamil Couples Who Found Love</title>
          <meta
            name="description"
            content="Read inspiring Tamil marriage success stories from Varankal.com – where real people find true love and lifelong happiness."
          />
          <meta
            name="keywords"
            content="Tamil Matrimony Success Stories, Tamil Couples, Varankal Weddings, Tamil Bride and Groom, Tamil Marriage Testimonials"
          />
        </Helmet>
        <h2 className="form-title">💖 Share Your Success Story</h2>
        <form onSubmit={handleSubmit} className="story-form">
          <div className="form-group">
            <label htmlFor="name"><FaUser className="icon" /> Names</label>
            <input
              type="text"
              id="name"
              name="name"
              value={story.name}
              onChange={handleChange}
              required
              placeholder="e.g., Sophia & Daniel"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="description"><FaPenFancy className="icon" /> Brief Description</label>
            <textarea
              id="description"
              name="description"
              value={story.description}
              onChange={handleChange}
              required
              placeholder="Share a short background of your love journey..."
              className="form-input"
            />
            <small>{story.description.trim().split(/\s+/).length || 0} / 20 words</small>
          </div>

          <div className="form-group">
            <label htmlFor="specialMoment"><MdCelebration className="icon" /> Special Moment</label>
            <textarea
              id="specialMoment"
              name="specialMoment"
              value={story.specialMoment}
              onChange={handleChange}
              required
              placeholder="That unforgettable moment..."
              className="form-input"
            />
            <small>{story.specialMoment.trim().split(/\s+/).length || 0} / 15 words</small>
          </div>

          <div className="form-group file-upload-group">
            <label>Upload a Photo or Video (Choose one)</label>
            <div className="file-wrapper">
              <label htmlFor="image" className="file-label">
                <FaImage className="icon" /> Upload Photo
                <input
                  type="file"
                  id="image"
                  name="image"
                  accept="image/*"
                  onChange={handleFileChange}
                  className="file-input"
                />
              </label>
              <label htmlFor="video" className="file-label">
                <FaVideo className="icon" /> Upload Video
                <input
                  type="file"
                  id="video"
                  name="video"
                  accept="video/*"
                  onChange={handleFileChange}
                  className="file-input"
                />
              </label>
            </div>
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="submit-btn">
            <AiOutlineSend className="icon" /> Submit Your Story
          </button>
        </form>
      </section>
    </>
  );
}

export default SuccessStoryForm;
